const map = {
	"./avatarF1.jpg": 11325,
	"./avatarF2.jpg": 73522,
	"./avatarF3.jpg": 49903,
	"./avatarF4.jpg": 7172,
	"./avatarF5.jpg": 80769,
	"./avatarM1.jpg": 82764,
	"./avatarM2.jpg": 25563,
	"./avatarM3.jpg": 54430,
	"./avatarM4.jpg": 65253,
	"./avatarM5.jpg": 2888
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80969;